export let routes = [
  {
    path: '/x3-side-grade',
    name: 'x3-side-grade',
    component: () => import('./grade.vue'),
    meta: {
      vx_animate: 'none',
    },
  }
];

export let api = {
  xsGrade(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-grade',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
};
